export const defaultStyles = {
  background: '#096EB6',
  borderColor: '#096EB6',
  glyphColor: '#fff',
  scale: 1.3
}

export const openedStyles = {
  ...defaultStyles,
  background: '#032137',
  borderColor: '#032137'
}

export const hoveredStyles = {
  ...defaultStyles,
  borderColor: '#ABBED1'
}
